import { Injectable, HostListener, OnInit  } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { Version, File } from '@core/objects';

@Injectable()
export class InterfaceListenerService {
  private documentClick$ = new BehaviorSubject<any>({});
  protected isCliked$ = this.documentClick$.asObservable();

  // version interface listeners for action on version feedback
  private onVersionFeedbackDoneSubject$ = new BehaviorSubject<Version>(null);
  private onFileAnnotationsSavedSubject$ = new BehaviorSubject<File>(null); // not used yet

  protected onFeedbackDone$ = this.onVersionFeedbackDoneSubject$.asObservable();
  protected onAannotationsSaved$ = this.onFileAnnotationsSavedSubject$.asObservable();

  // this triggers a change any time action was performed by user
  setDocumentClick(click: PointerEvent) {
    this.documentClick$.next(click);
  }

  // get the observable to subscribe to document click events
  getDocuementClicked$(){
    return this.isCliked$;
  }

  // trigger version feedback done Archived or completed
  triggerFeedbackDone(version:Version){
    console.debug(" trigger version feedback done for ",version)
    this.onVersionFeedbackDoneSubject$.next(version);
  }

  getVersionFeedbackDone(): Observable<Version> {
    return this.onFeedbackDone$;
  }

  // trigger file annotations saved
  triggerFileAnnotationsSaved(file:File){
    console.debug(" trigger file annotation saved for ",file)
    this.onFileAnnotationsSavedSubject$.next(file);
  }

  getFileAnnotationsSaved(): Observable<File> {
    return this.onAannotationsSaved$;
  }
}

